import { useTranslation } from 'react-i18next';
import './flowry.css';

export const CLAUDE_MARK =
  'm4.7144 15.9555 4.7174-2.6471.079-.2307-.079-.1275h-.2307l-.7893-.0486-2.6956-.0729-2.3375-.0971-2.2646-.1214-.5707-.1215-.5343-.7042.0546-.3522.4797-.3218.686.0608 1.5179.1032 2.2767.1578 1.6514.0972 2.4468.255h.3886l.0546-.1579-.1336-.0971-.1032-.0972L6.973 9.8356l-2.55-1.6879-1.3356-.9714-.7225-.4918-.3643-.4614-.1578-1.0078.6557-.7225.8803.0607.2246.0607.8925.686 1.9064 1.4754 2.4893 1.8336.3643.3035.1457-.1032.0182-.0728-.164-.2733-1.3539-2.4467-1.445-2.4893-.6435-1.032-.17-.6194c-.0607-.255-.1032-.4674-.1032-.7285L6.287.1335 6.6997 0l.9957.1336.419.3642.6192 1.4147 1.0018 2.2282 1.5543 3.0296.4553.8985.2429.8318.091.255h.1579v-.1457l.1275-1.706.2368-2.0947.2307-2.6957.0789-.7589.3764-.9107.7468-.4918.5828.2793.4797.686-.0668.4433-.2853 1.8517-.5586 2.9021-.3643 1.9429h.2125l.2429-.2429.9835-1.3053 1.6514-2.0643.7286-.8196.85-.9046.5464-.4311h1.0321l.759 1.1293-.34 1.1657-1.0625 1.3478-.8804 1.1414-1.2628 1.7-.7893 1.36.0729.1093.1882-.0183 2.8535-.607 1.5421-.2794 1.8396-.3157.8318.3886.091.3946-.3278.8075-1.967.4857-2.3072.4614-3.4364.8136-.0425.0304.0486.0607 1.5482.1457.6618.0364h1.621l3.0175.2247.7892.522.4736.6376-.079.4857-1.2142.6193-1.6393-.3886-3.825-.9107-1.3113-.3279h-.1822v.1093l1.0929 1.0686 2.0035 1.8092 2.5075 2.3314.1275.5768-.3218.4554-.34-.0486-2.2039-1.6575-.85-.7468-1.9246-1.621h-.1275v.17l.4432.6496 2.3436 3.5214.1214 1.0807-.17.3521-.6071.2125-.6679-.1214-1.3721-1.9246L14.38 17.959l-1.1414-1.9428-.1397.079-.674 7.2552-.3156.3703-.7286.2793-.6071-.4614-.3218-.7468.3218-1.4753.3886-1.9246.3157-1.53.2853-1.9004.17-.6314-.0121-.0425-.1397.0182-1.4328 1.9672-2.1796 2.9446-1.7243 1.8456-.4128.164-.7164-.3704.0667-.6618.4008-.5889 2.386-3.0357 1.4389-1.882.929-1.0868-.0062-.1579h-.0546l-6.3385 4.1164-1.1293.1457-.4857-.4554.0608-.7467.2307-.2429 1.9064-1.3114Z';

export const GPT_MARK =
  'M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z';

const SOURCES = [
  { label: 'Salesforce', icon: '/logos/salesforce.svg' },
  { label: 'SAP', icon: '/logos/sap.svg' },
  { label: 'HubSpot', icon: '/logos/hubspot.svg' },
  { label: 'Oracle', icon: '/logos/oracle.svg' },
  { label: 'Slack', icon: '/logos/slack.svg' },
];

const LINES: { d: string; delay: string; opacity: number }[] = [
  { d: 'M133 38 C 167 38, 144 170, 174 170', delay: '0s', opacity: 0.55 },
  { d: 'M133 104 C 167 104, 144 170, 174 170', delay: '-0.3s', opacity: 0.55 },
  { d: 'M133 170 C 167 170, 144 170, 174 170', delay: '-0.6s', opacity: 0.55 },
  { d: 'M133 236 C 167 236, 144 170, 174 170', delay: '-0.9s', opacity: 0.55 },
  { d: 'M133 302 C 167 302, 144 170, 174 170', delay: '-1.2s', opacity: 0.55 },
  { d: 'M278 170 C 306 170, 294 134, 322 134', delay: '0s', opacity: 0.75 },
  { d: 'M278 170 C 306 170, 294 206, 322 206', delay: '-0.5s', opacity: 0.75 },
];

const FlowDiagram = () => {
  const { t } = useTranslation();

  return (
    <figure className="flow-diagram" aria-label={t('diagram_aria')}>
      <div className="flow-diagram-dots" aria-hidden="true" />
      <svg viewBox="0 0 480 340" role="presentation">
        <g fill="none" strokeLinecap="round">
          {LINES.map((line) => (
            <g key={line.d}>
              <path d={line.d} stroke="#E6E5E0" strokeWidth="1.25" />
              <path
                d={line.d}
                stroke="#1F6B53"
                strokeWidth="1.25"
                className="flow-line"
                style={{ animationDelay: line.delay, opacity: line.opacity }}
              />
            </g>
          ))}
        </g>
        {SOURCES.map((source, index) => {
          const y = 17 + index * 66;
          return (
            <g key={source.label}>
              <rect x="1" y={y} width="132" height="42" rx="10" fill="#FFFFFF" stroke="#E6E5E0" />
              <image href={source.icon} x="12" y={y + 11} width="20" height="20" />
              <text x="38" y={y + 21} dominantBaseline="central" fill="#0E0F0E" fontSize="13" fontWeight="500">
                {source.label}
              </text>
            </g>
          );
        })}
        <g>
          <rect x="174" y="142" width="104" height="56" rx="14" fill="#0E0F0E" />
          <circle cx="196" cy="170" r="3.5" fill="#5FB394" className="flow-pulse" />
          <text x="208" y="170" dominantBaseline="central" fill="#F6F5F1" fontSize="16" fontWeight="600" letterSpacing="-0.3">
            Flowry
          </text>
        </g>
        <g>
          <rect x="322" y="108" width="157" height="52" rx="12" fill="#FFFFFF" stroke="#D4D3CC" />
          <rect x="334" y="120" width="28" height="28" rx="8" fill="#FBF1EC" />
          <svg x="340" y="126" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path d={CLAUDE_MARK} fill="#D97757" />
          </svg>
          <text x="372" y="127" dominantBaseline="central" fill="#0E0F0E" fontSize="14" fontWeight="600">
            Claude
          </text>
          <text x="372" y="144" dominantBaseline="central" fill="#6F6E68" fontSize="8.5" letterSpacing="0.4">
            BY ANTHROPIC
          </text>
        </g>
        <g>
          <rect x="322" y="180" width="157" height="52" rx="12" fill="#FFFFFF" stroke="#D4D3CC" />
          <rect x="334" y="192" width="28" height="28" rx="8" fill="#F2F2EE" />
          <svg x="340" y="198" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
            <path d={GPT_MARK} fill="#0E0F0E" />
          </svg>
          <text x="372" y="199" dominantBaseline="central" fill="#0E0F0E" fontSize="14" fontWeight="600">
            GPT
          </text>
          <text x="372" y="216" dominantBaseline="central" fill="#6F6E68" fontSize="8.5" letterSpacing="0.4">
            BY OPENAI
          </text>
        </g>
      </svg>
      <figcaption>
        <span>{t('diagram_tools')}</span>
        <span className="flow-diagram-name">{t('diagram_flowry')}</span>
        <span>{t('diagram_assistants')}</span>
      </figcaption>
    </figure>
  );
};

export default FlowDiagram;
